module.exports = __webpack_public_path__ + "img/flecha-right.3fc25c9a.svg";